import MapConst from '@/constants/topologymap';

const topologymap = {
  state: {
    /**
     * 현재 맵 아이디
     * @type {Number}
     */
    currentMapId: null,
    /**
     * View 모드
     * @type {String}
     */
    viewMode: MapConst.VIEW_MODE.MONITORING,
    /**
     * 컨텍스트 메뉴 아이템
     * @type {Array}
     */
    contextMenuItems: [],
    /**
     * 컨텍스트 메뉴를 생성한 타켓
     * @type {VueComponent}
     */
    contextMenuTarget: null,
    /**
     * 맵 경로
     * @type {Array}
     */
    breadcrumb: [],
    /**
     * 이벤트 등급 정보
     * @type {Object}
     */
    eventlevel: {},
    /**
     * 오브젝트 추가 모드
     * @type {String}
     */
    attachMode: MapConst.ATTACH_MODE.ADD,

    /**
     * 전체화면 여부
     * @type {Boolean}
     */
    fullScreen: false,

    refreshOptions: null,

    timelineExpand: false,

    mapTreeCollapse: false,

    automapDeviceTableExpand: false,

    automapInfo: null,
  },
  getters: {
    getCurrentMapId(state) {
      return state.currentMapId;
    },
    getTopologymapViewMode(state) {
      return state.viewMode;
    },
    getContextMenuItems(state) {
      return state.contextMenuItems;
    },
    getContextMenuTarget(state) {
      return state.contextMenuTarget;
    },
    getBreadcrumb(state) {
      return state.breadcrumb;
    },
    getEventlevel(state) {
      return state.eventlevel;
    },
    getAttachMode(state) {
      return state.attachMode;
    },
    isFullScreen(state) {
      return state.fullScreen;
    },
    getRefreshOptions(state) {
      return state.refreshOptions;
    },
    isTimelineExpand(state) {
      return state.timelineExpand;
    },
    isMapTreeCollapse(state) {
      return state.mapTreeCollapse;
    },
    isAutomapDeviceTableExpand(state) {
      return state.automapDeviceTableExpand;
    },
    getAutomapInfo(state) {
      return state.automapInfo;
    },
  },
  mutations: {
    setCurrentMapId(state, mapId) {
      state.currentMapId = mapId;
    },
    setTopologymapViewMode(state, viewMode) {
      state.viewMode = viewMode;
    },
    setContextMenuItems(state, contextMenuItems) {
      const key = new Date().getTime();
      contextMenuItems.forEach((item, idx) => {
        item.id = `${key}.${idx}`; // 매번 id 값을 유일하게 설정한다.
      });
      state.contextMenuItems = contextMenuItems;
    },
    setContextMenuTarget(state, contextMenuTarget) {
      state.contextMenuTarget = contextMenuTarget;
    },
    setBreadcrumb(state, breadcrumb) {
      state.breadcrumb = breadcrumb;
    },
    setEventlevel(state, eventlevel) {
      state.eventlevel = eventlevel;
    },
    setAttachMode(state, attachMode) {
      state.attachMode = attachMode;
    },
    setFullScreen(state, fullScreen) {
      state.fullScreen = fullScreen;
    },
    setRefreshOptions(state, refreshOptions) {
      state.refreshOptions = refreshOptions;
    },
    setTimelineExpand(state, timelineExpand) {
      state.timelineExpand = timelineExpand;

      // 로컬스토리지에 저장
      localStorage.setItem('mapTimelineExpand', timelineExpand);
    },
    setMapTreeCollapse(state, mapTreeCollapse) {
      state.mapTreeCollapse = mapTreeCollapse;

      if (state.viewMode !== MapConst.VIEW_MODE.EDIT) {
        // 로컬스토리지에 저장
        localStorage.setItem('mapTreeCollapse', mapTreeCollapse);
      }
    },
    setAutomapDeviceTableExpand(state, automapDeviceTableExpand) {
      state.automapDeviceTableExpand = automapDeviceTableExpand;
    },
    setAutomapInfo(state, automapInfo) {
      state.automapInfo = automapInfo;
    },
  },
  actions: {
    showContextmenu(store, params) {
      store.commit('setContextMenuItems', params.items);
      window.$$VContextmenu.undefined.show({
        top: params.graph.globalToLocal(params.evt).y,
        left: params.graph.globalToLocal(params.evt).x,
      });
      store.commit('setContextMenuTarget', params.target);
    },
  },
};

export default topologymap;



// WEBPACK FOOTER //
// ./src/store/modules/topologymap.js